import type { Env } from '@sparklayer-io/spark-dash-core/context/env-context';

/** The onboarding flags tracked on `env`, in the order they're shown. */
export const ONBOARDING_STEP_KEYS = [
  'onboarding_platform',
  'onboarding_frontend',
  'onboarding_sync',
  'onboarding_settings',
  'onboarding_launch',
] as const satisfies readonly (keyof Env)[];

export type OnboardingStepKey = (typeof ONBOARDING_STEP_KEYS)[number];

/** Wix has no storefront widgets step, so it's skipped for that platform. */
export function onboardingStepKeys(env: Env): OnboardingStepKey[] {
  return ONBOARDING_STEP_KEYS.filter(
    (key) => key !== 'onboarding_frontend' || env.connected_platform !== 'wix',
  );
}

export function onboardingStepsCompleted(env: Env): number {
  return onboardingStepKeys(env).filter((key) => env[key]).length;
}

export function isOnboardingComplete(env: Env): boolean {
  const keys = onboardingStepKeys(env);
  return keys.length > 0 && keys.every((key) => env[key]);
}
